import {db} from "@src/services/db";
import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import {useWindowFocus} from "@vueuse/core";
import type {ChatMessageReaction, ChatMessageReactionEvent} from "@src/types/ChatMessageReaction";

function getMessageId(event: ChatMessageReactionEvent): number | null {
    if (event.chat_message?.id) return Number(event.chat_message.id);
    if (event.chatMessage?.id) return Number(event.chatMessage.id);
    if (event.chat_message_id) return Number(event.chat_message_id);
    return null;
}

function toFrontReaction(event: ChatMessageReactionEvent): ChatMessageReaction | null {
    let data: ChatMessageReaction = {
        emoji: event.reaction,
        costumer_id: 0,
        user_id: 0
    }
    if (!event.user_id && !event.costumer_id) {
        return null
    }
    const isCustomer = event.user_id === null || event.user_id === undefined;
    if (isCustomer) {
        if (!event.costumer_id) {
            return null
        }
        data.costumer_id = event.costumer_id
    } else {
        if (!event.user_id) {
            return null
        }
        data.user_id = event.user_id
    }

    return data;
}

export function ReactionListener() {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();
    const focused = useWindowFocus();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets
        .private(`user.${userId}`)
        .listen(".ReactionEvent", async (event: ChatMessageReactionEvent) => {
            try {
                const msgId = getMessageId(event);
                if (!msgId) return;

                const message = sessionStore.selectedSession?.messages?.find(
                    (m: any) => Number(m.id) === msgId
                );

                if (!message) {
                    return
                }

                if (!Array.isArray((message as any).reactions)) {
                    (message as any).reactions = [];
                }

                const next = toFrontReaction(event);
                if (!next) {
                    return
                }

                // 1 reação por autor (user/costumer id colapsado)
                const idx = (message as any).reactions.findIndex(
                    (r: ChatMessageReaction) => (r.user_id === next.user_id && r.user_id !== 0) || (r.costumer_id === next.costumer_id && r.costumer_id !== 0)
                );

                if (idx !== -1) {
                    (message as any).reactions.splice(idx, 1)
                }

                if (next.emoji !== 'remove') {
                    (message as any).reactions.push(next);
                }

                await db.messages.update(msgId as any, {
                    reactions: (message as any).reactions,
                    updated_at: Date.now(),
                } as any);
            } catch (e) {
                console.error("❌ erro no listener ReactionEvent", e);
            }
        });
}
